module.exports = __webpack_public_path__ + "static/media/cobranca.c87a9d26.svg";